import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Loading from '@hellodarwin/core/lib/components/loading';
import Confirm from '@hellodarwin/icons/dist/icons/Confirm';
import TabArrow from '@hellodarwin/icons/dist/icons/TabArrow';
import XCircle from '@hellodarwin/icons/dist/icons/XCircle';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { ToolStatus } from '../../../types/tool.types';
import { ToolCallInline } from '../styles';
import { getToolStatusText } from '../tool-card-config';
import { ToolCallInlineRowContainer } from './styles';
export const ToolCallInlineRow = ({ model, isExpanded, onToggle, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const getStatusIcon = (size = 16) => {
        switch (model.status) {
            case ToolStatus.PENDING:
            case ToolStatus.RUNNING:
                return (_jsx(ToolCallInlineRowContainer, { children: _jsx(Loading, { size: "small" }) }));
            case ToolStatus.SUCCESS:
                return _jsx(Confirm, { size: size, color: theme.colors.green_high_contrast });
            case ToolStatus.FAILURE:
                return _jsx(XCircle, { size: size, color: theme.colors.error });
            case ToolStatus.PARTIAL:
                return _jsx(Confirm, { size: size, color: theme.colors.orange_1 });
            default:
                return null;
        }
    };
    const toolLabel = t(model.labelKey, model.toolName);
    const toolStatusText = getToolStatusText(model.status, (key, fallback) => t(key, fallback), model.errorText);
    return (_jsxs(ToolCallInline, { status: model.status, "$expandable": !!onToggle, onClick: onToggle, children: [getStatusIcon(16), _jsxs("span", { children: [toolLabel, model.status !== ToolStatus.PENDING &&
                        model.status !== ToolStatus.RUNNING &&
                        model.executionTime && _jsxs(_Fragment, { children: [" \u2022 ", model.executionTime] }), model.status === ToolStatus.RUNNING && _jsxs(_Fragment, { children: [" \u2014 ", toolStatusText] }), model.status === ToolStatus.FAILURE && _jsxs(_Fragment, { children: [" \u2014 ", toolStatusText] })] }), onToggle && _jsx(TabArrow, { down: isExpanded, size: 16 })] }));
};
export default ToolCallInlineRow;
